export interface DepartmentAgeGroupsProperties {
  [key: string]: string[];
  Men: string[];
  Women: string[];
  Unisex: never[];
  Boys: string[];
  Girls: string[];
  Kids: string[];
  Baby: string[];
}

const departmentAgeGroups: DepartmentAgeGroupsProperties = {
  Men: ['ADULTS'],
  Women: ['ADULTS'],
  Unisex: [],
  Boys: ['CHILDREN'],
  Girls: ['CHILDREN'],
  Kids: ['CHILDREN'],
  Baby: ['BABIES'],
};

export default departmentAgeGroups;
